module.exports = __webpack_public_path__ + "static/Nicky-Wrightson.64f4a6a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/speakers/Nicky-Wrightson.jpg
// module id = 583
// module chunks = 183393319013223